import React, { useEffect, useRef, useState } from 'react'

const CheckBox = ({ className = "", label, labelSpacing = 'space-x-2', groupLabel = '', onChange = () => {}, ...props }) => {
  const [isChecked, setIsChecked] = useState(false)
  const isFirstRender = useRef(true)

  useEffect(() => {
    if(isFirstRender.current) {
      isFirstRender.current = false
      return
    }

    onChange(isChecked)
  }, [isChecked])

  return (
    <React.Fragment>
      <label className={`flex items-center ${labelSpacing} ${className}`}>
        <input
          type="checkbox"
          className="w-4 h-4 p-1 accent-gray-700 border-gray-300 rounded-md focus:ring-gray-500"
          checked={props.checked !== undefined ? props.checked : isChecked}
          onChange={() => setIsChecked(!isChecked)}
          aria-label={`${groupLabel}-${label}`}
        />
        <span>{ label }</span>
      </label>
    </React.Fragment>
  )
}

export default CheckBox